<template>
    <div class="md-chips md-primary md-theme-default" v-if="items.length > 0">
        <div class="md-chip md-theme-default" v-for="(item, index) in items" :key="index">
            {{ item }}
        </div>
    </div>
    <div v-else>
        {{ noneLabel }}
    </div>
</template>

<script>
export default {
    name: 'GridChipsRenderer',
    data() {
        return {
            items: [],
            noneLabel: 'None'
        };
    },
    beforeMount() {
        this.items = this.params.value.items;
        this.noneLabel = this.params.value.noneLabel ? this.params.value.noneLabel : 'None';
    }
};
</script>
